import styles from './YoungWashingtonView.module.css'
import { ApolloProvider } from '@apollo/client'
import Head from 'next/head'
import { Analytics } from '@/layout/Analytics'
import { ErrorBoundary, ErrorFallback } from '@/layout/ErrorBoundary'
import { getWebClient } from '@/services/ApolloClient'
import { useLocale } from '@/utils/LocaleUtil'

const FAVICON = 'https://images.angelstudios.com/image/upload/v1756398012/angel-web/favicon.png'
const CANONICAL_URL = 'https://www.angel.com/preorder/young-washington'
const PAGE_TITLE = 'Young Washington | Pre-Order Tickets for July 4, 2026'
const META_DESCRIPTION =
  'Pre-order tickets today for the epic untold story of America’s first hero. Help make Young Washington the biggest movie in theaters on America’s 250th Birthday.'
const OG_DESCRIPTION =
  'Pre-order tickets today for the epic untold story of America’s first hero. Help make Young Washington the biggest movie in theaters on America’s 250th Birthday.'
const OG_IMAGE =
  'https://images.angelstudios.com/image/upload/v1760142008/theatrical/young%20washington/open-graph-yw-251010.jpg'
const SITE_NAME = 'Angel Studios'
const TWITTER_SITE = '@AngelStudiosInc'

export default function Layout({ children }: { children: React.ReactNode }) {
  const { locale } = useLocale()
  const client = getWebClient({ locale })

  return (
    <ErrorBoundary FallbackComponent={ErrorFallback}>
      <Head>
        <title>{PAGE_TITLE}</title>

        {/* Canonical + robots */}
        <link rel="canonical" href={CANONICAL_URL} />
        <meta name="robots" content="index,follow" />

        {/* Favicon */}
        <link rel="icon" href={FAVICON} />
        <link rel="shortcut icon" href={FAVICON} />
        <link rel="apple-touch-icon" href={FAVICON} />

        {/* Theme color */}
        <meta name="theme-color" content="#0B0B0D" />

        {/* Standard meta description */}
        <meta name="description" content={META_DESCRIPTION} />

        {/* OpenGraph */}
        <meta property="og:type" content="website" />
        <meta property="og:url" content={CANONICAL_URL} />
        <meta property="og:title" content={PAGE_TITLE} />
        <meta property="og:description" content={OG_DESCRIPTION} />
        <meta property="og:image" content={OG_IMAGE} />
        <meta property="og:image:alt" content="Young Washington" />
        <meta property="og:site_name" content={SITE_NAME} />
        <meta property="og:locale" content="en_US" />

        {/* Twitter Card */}
        <meta name="twitter:card" content="summary_large_image" />
        <meta name="twitter:title" content={PAGE_TITLE} />
        <meta name="twitter:description" content={OG_DESCRIPTION} />
        <meta name="twitter:image" content={OG_IMAGE} />
        <meta name="twitter:image:alt" content="Young Washington" />
        <meta name="twitter:site" content={TWITTER_SITE} />
      </Head>
      <Analytics>
        <ApolloProvider client={client}>
          <div className={styles.fontCompactaCom}>{children}</div>
        </ApolloProvider>
      </Analytics>
    </ErrorBoundary>
  )
}
